import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { levels, levelsTitle } from "./enums";
/**
 * Category class
 */

export class Category extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getId = () => Number(this.model.id);

    this.getLevel = (asLabel = false) => {
      return asLabel ? Category.levelsTitle[this.model.level || 'unknown'] || Category.levelsTitle['unknown'] : this.model.level;
    };

    this.getTitle = () => this.model.title;

    this.getAlias = () => this.model.alias;

    this.getSort = () => Number(this.model.sort);

    this.isVisible = () => this.model.isVisible;

    this.getCreatedAt = () => this.model.createdAt;

    this.getUpdatedAt = () => this.model.updatedAt;

    this.isChildrenExist = () => this.model.isChildrenExist;

    this.getChildrens = () => this.model.childrens;

    this.isGroupsExist = () => Boolean(this.model.groups);

    this.getGroups = () => this.model.groups || [];

    this.getAllParents = () => this.model.allParents || [];

    this.getParentCategories = categories => {
      return this.getRelation('parentCategories', Category, categories, true);
    };

    this.getChildCategories = categories => {
      return this.getRelation('childrenCategories', Category, categories, true);
    };
  }

  /**
   * Create category
   *
   * @param {object} object
   *
   * @return {Category}
   */
  static create(object) {
    return super.create(object?.result?.model ?? object?.result ?? object);
  }
  /**
   * Create list categories
   *
   * @param {object} objects
   *
   * @return {Array.<Category>}
   */


  static createList(objects) {
    return super.createList(objects);
  }
  /**
   * Map categories
   *
   * @param {Array.<object>} objects
   * @param {function(Category): undefined} callback
   *
   * @return {Array.<object>}
   */


  static map(objects, callback) {
    return super.map(objects, callback);
  }
  /**
   * Get category id
   *
   * @return {number}
   */


}
Category.levels = levels;
Category.levelsTitle = levelsTitle;